
import { FetchReturn } from '@nuxt/content/types/query-builder'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'PilotEvaluationAgreement',
  props: {
    content: {
      type: [Object, Array] as PropType<FetchReturn | Array<FetchReturn>>,
      required: true
    }
  }
})
